// @ts-check

import React, { Component, Fragment } from "react"
import DatePicker from "ui/legacy/DatePicker"
// import { boolean, text } from "../../_Editor/Attributes/_Composed"
import { boolean, text } from "features/editor/attributes/items/primitives"
import DefineProperty from "features/editor/properties/DefineProperty"

/**
 * @augments {Component<BlockTypeProps, {datetime?: Date}>}
 */
export default class DateTimeBlockType extends Component {
    state = {}
    render() {
        const Wrapper = this.props.Wrapper

        return (
            <Wrapper {...this.props}>
                {({ attrs }) => (
                    <Fragment>
                        <DefineProperty
                            name="datetime"
                            value={this.state.datetime}
                            type="date"
                            tags={["form"]}
                        />

                        <DatePicker
                            onChange={datetime => this.setState({ datetime })}
                            showTimeSelect={attrs.datetime}
                            selected={this.state.datetime}
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            dateFormat={attrs.datetime ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY"}
                            timeCaption="time"
                            placeholderText={attrs.placeholder}
                        />
                    </Fragment>
                )}
            </Wrapper>
        )
    }
}

DateTimeBlockType.attributes = [
    boolean({ field: "datetime", label: "datetime?" }),
    text({ field: "placeholder", label: "Placeholder" }),
]



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/form/DateTimeBlock.js